export const createInitialStateFromModel = (model) =>
  model.reduce((prev, curr) => {
    const obj = { ...prev };
    obj[curr.key] = curr.value || '';
    return { ...obj };

  }, {});